import React from 'react';
import { useTranslation } from 'react-i18next';
import ValeComponentActivableCanjeable from '../ValeComponentActivableCanjeable';
import tarjetaCaprabo from '../../../assets/images/tarjetas-caprabo.png';
import tarjetaEroski from '../../../assets/images/tarjeta-eroski-cupon-cropped.png';
import IconCheckWhite from '../../../Icons/IconCheckWhite';

const CuponMasivo = ({
  oferta,
  data,
  dataApp,
  unidad,
  isEroski,
  isDestacado,
  isCanjeado,
}) => {
  const { t, i18n } = useTranslation();
  const idioma = i18n.language;
  const isTipoValeMonedero: boolean = data?.tipoVale === 'ValeMonedero';
  const textoReclamo = () => {
    if (data?.textoReclamo?.toUpperCase() === 'GRATIS') {
      return (
        <>
          {/* <span className="bloque-vale__gratis"> */}
          <span className="bloque-vale__num">
            {t('vales.gratis').toUpperCase()}
          </span>
        </>
      );
    }
    return null;
  };

  const offer = () => {
    return (
      <span className="bloque-vale__num ">
        {oferta}
        <sup>{unidad}</sup>
      </span>
    );
  };

  const isLangEU = () => {
    return dataApp.lang === 'eu' && unidad === '%';
  };

  const offerEU = () => {
    return (
      <span className="bloque-vale__num">
        <sup>{unidad}</sup>
        {oferta}
      </span>
    );
  };
  const isFree = () => {
    return data?.textoReclamo?.toUpperCase() === 'GRATIS';
  };

  const imageProvider = () => {
    return isEroski ? (
      <img src={tarjetaEroski} alt="imagen de las tarjetas Eroski" />
    ) : (
      <img src={tarjetaCaprabo} alt="imagen de las tarjetas Caprabo" />
    );
  };

  return (
    <div
      id="cupon-masivo"
      className={`bloque-vale-content__wrapper ${
        isCanjeado ? 'bloque-vale--canjeado ' : ''
      }${isDestacado ? 'bloque-vale--destacado ' : ''}${
        oferta.length > 2 ? 'bloque-vale__num-redu' : ''
      }`}
    >
      {data.tipoLista !== 5 && !isCanjeado && (
        <div className="icon-activado">
          <div className="icon icon-medium">
            <IconCheckWhite classCss="" />
          </div>
        </div>
      )}
      <ValeComponentActivableCanjeable vale={data} />
      <div className="bloque-vale-content__image-info">
        <div className="bloque-vale-content__image">
          <span className="bloque-vale-content__image-offer">
            {/* <img src={cesta} alt="cesta" /> */}
          </span>
          {isTipoValeMonedero ? imageProvider() : ''}
        </div>
        <div className="bloque-vale-content__info">
          <div className="bloque-vale-content__info-offer">
            {idioma === 'en' && <p>{t('vales.masivos.descuento')}</p>}
            <span>
              {isFree() && textoReclamo()}
              {!isFree() && isLangEU() && offerEU()}
              {!isFree() && !isLangEU() && offer()}
            </span>
            {idioma !== 'en' && <p>{t('vales.masivos.descuento')}</p>}
          </div>
          {data.cantidadMinimaReclamo && (
            <p>
              <span>{t('vales.masivos.compra-minima')}</span>
              <strong>{` ${data.cantidadMinimaReclamo} €
              `}</strong>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CuponMasivo;
